// /mnt/mantenimientos/frontend/src/api.js
import axios from "axios";

/* =========================================================
   INSTANCIA AXIOS PROPIA (SaaS)
========================================================= */

const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
  timeout: 20000,
});

/* =========================================================
   INTERCEPTORS
========================================================= */

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      console.warn("Sesión expirada o no autorizada");
      // localStorage.clear();
      // window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

/* =========================================================
   CLIENTES
========================================================= */

export const getClientes = () => api.get("/clientes");
export const getCliente = (id) => api.get(`/clientes/${id}`);
export const crearCliente = (data) => api.post("/clientes", data);
export const actualizarCliente = (id, data) => api.put(`/clientes/${id}`, data);
export const eliminarCliente = (id) => api.delete(`/clientes/${id}`);

/* =========================================================
   ACCESO EFECTIVO
========================================================= */

export const getEffectiveAccess = () => api.get("/access-control/me");

/* =========================================================
   USUARIOS Y CONCESIONES
========================================================= */

export const getUsuarios = () => api.get("/usuarios");
export const crearUsuario = (data) => api.post("/usuarios", data);
export const actualizarUsuario = (id, data) => api.put("/usuarios/" + id, data);
export const desactivarUsuario = (id) => api.delete("/usuarios/" + id);
export const getUserAccess = (userId) => api.get("/access-control/users/" + userId);
export const updateUserAccess = (userId, data) => api.put("/access-control/users/" + userId, data);

/* =========================================================
   ORDENADORES
========================================================= */

export const getOrdenadoresPorCliente = (clienteId) =>
  api.get(`/clientes/${clienteId}/ordenadores`);

export const getOrdenadores = () => api.get("/ordenadores");

export const crearOrdenador = (data) => api.post("/ordenadores", data);

export const actualizarOrdenador = (id, data) =>
  api.put(`/ordenadores/${id}`, data);

export const actualizarOrdenadorSpecs = (id, data) =>
  api.put(`/ordenadores/${id}/specs`, data);

export const eliminarOrdenador = (id) => api.delete(`/ordenadores/${id}`);
export const actualizarCicloVidaOrdenador = (id, data) =>
  api.patch(`/ordenadores/${id}/lifecycle`, data);
export const actualizarInfoOperativaOrdenador = (id, info_adicional) =>
  api.patch(`/ordenadores/${id}/operational-info`, { info_adicional });

/* =========================================================
   MANTENIMIENTOS
========================================================= */

export const getMantenimientos = () => api.get("/mantenimientos");

export const getMantenimientosPorCliente = (clienteId) =>
  api.get(`/mantenimientos/cliente/${clienteId}`);

export const getMantenimientosPorPc = (pcId) =>
  api.get(`/mantenimientos/${pcId}`);

export const crearMantenimiento = (data) =>
  api.post("/mantenimientos", data);

export const getPendientes = () => api.get("/mantenimientos/pendientes");
export const getMiTrabajoMantenimiento = () => api.get("/mantenimientos/mi-trabajo");

export const getFaltantesMes = (clienteId, mes) =>
  api.get(`/mantenimientos/faltantes/${clienteId}/${mes}`);

export const verificarMantenimientoMes = (clienteId, mes) =>
  api.get(`/mantenimientos/verificar/${clienteId}/${mes}`);

export const generarInforme = (clienteId, mes) =>
  api.get(`/mantenimientos/generar/${clienteId}/${mes}`);

/* =========================================================
   INFORMES
========================================================= */

export const getInformesPorCliente = (clienteId) =>
  api.get(`/informes/${clienteId}`);
export const getInformesPendientes = () => api.get("/informes/pendientes");

export const getTodosLosInformes = () => api.get("/informes");
export const eliminarInforme = (numero) => api.delete("/informes/" + numero);
export const revisarInforme = (id) => api.post("/informes/" + id + "/revisar");
export const enviarInforme = (id) => api.post("/informes/" + id + "/enviar");
export const regenerarInforme = (numero) => api.post("/informes/regenerar/" + numero);
export const getInformePdf = (numero) => api.get("/informes/" + numero + "/pdf", { responseType: "blob" });

export const verInformePDF = (clienteId, mes) =>
  api.get(`/informes/${clienteId}/${mes}`, {
    responseType: "blob",
  });

/* =========================================================
   MONITORIZACIÓN (ZABBIX)
========================================================= */

export const getZabbixDashboardCliente = (tag) =>
  api.get(
    `/monitorizacion/zabbix/cliente/${encodeURIComponent(tag)}/pc-dashboard`
  );

/* =========================================================
   COPIAS SYNCBACK (TRANSICION)
========================================================= */

export const getLatestBackupLogs = () => api.get("/logs/ui/ultimos");
export const getBackupLogHistory = (params) => api.get("/logs/ui/historial", { params });

/* =========================================================
   SECRETOS (credenciales)
========================================================= */

export const getSecretosTipos = () => api.get("/secretos/tipos");
export const getSecretosPorEquipo = (ordenadorId) => api.get("/secretos/equipo/" + ordenadorId);
export const getSecretosStatsPorEquipo = (ordenadorId) => api.get("/secretos/equipo/" + ordenadorId + "/stats");

export const getSecretosBundle = (clienteId) =>
  api.get("/secretos/bundle", {
    params: { cliente_id: clienteId },
  });

export const crearSecreto = (data) => api.post("/secretos", data);

export const actualizarSecreto = (id, data) =>
  api.put(`/secretos/${id}`, data);

export const eliminarSecreto = (id) => api.delete(`/secretos/${id}`);

export const revealSecreto = (id) => api.post(`/secretos/${id}/reveal`);

export default api;
